// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"267":"fbe39e84","868":"7639cc7c"}[chunkId] + ".chunk.js";
};